<template>
  <v-app>
    <router-view name="header" />
    <v-main>
      <router-view name="main" />
    </v-main>
    <div style="height:50px" />
    <router-view name="footer" />
  </v-app>
</template>

<script>
export default {
  name: "App",
  data: () => ({  }),
}

</script>

<style>
h1 {
  font-size: 3em;
  font-weight: 400;
}

h2 {
  font-size: 2em;
  font-weight: 300;
  color: gray;
}

h3 {
  font-size: 1.5em;
  font-weight: 300;
  color: gray;
}

h4 {
  font-size: 1.2em;
  font-weight: 300;
  color: gray;
}

</style>
